<template>
    <section class="app">
        <section class="header">
            <div class="logo">
                <img src="../../assets/imgs/logo.svg">
            </div>
            <div class="nav">
                <ul>
                    <li>
                        <router-link to="/dashboard"><i class="fal fa-home-lg-alt"></i> Dashboard</router-link>
                    </li>
                    <li>
                        <router-link to="/minha-conta"><i class="fal fa-address-card"></i>  Minha conta</router-link>
                    </li>
                    <li v-if="isPermission('edit_my_curriculum')">
                        <router-link to="/meu-curriculo"><i class="fal fa-address-card"></i> Meu Currículo</router-link>
                    </li>
                    <li v-if="isPermissions('tickets_list,tickets_list_my,tickets_list_my_responsibility')">
                        <router-link to="/ouvidoria"><i class="fal fa-user-headset"></i> Ouvidoria</router-link>
                    </li>
                    <li v-if="isPermission('jobs_list')">
                        <router-link to="/vagas-de-emprego"><i class="fal fa-user-tie"></i> Vagas de Empregos</router-link>
                    </li>
                    <li v-if="isPermission('users_list')">
                        <router-link to="/usuarios/todos"><i class="fal fa-user"></i> Usuários</router-link>
                    </li>
                    <li v-if="isPermission('config_manager')">
                        <router-link to="/configuracoes"><i class="fal fa-cog"></i> Configurações</router-link>
                    </li>
                    <li>
                        <a href="#" @click="logout()"><i class="fal fa-power-off"></i> </a>
                    </li>
                    
                </ul>
            </div>
            <div>
                <a href="#" class="go-site">Ir para o site</a>
            </div>
        </section>
        <section class="body">
            <slot />
        </section>
        <section class="footer">
            <div>Sistema de Relacionamento e Recrutamento</div>
            <div>
                <img src="../../assets/imgs/afixar.svg" height="17">
            </div>
        </section>
    </section>
</template>

<script>
    import { storage } from '@/services'
    import permissions from '@/mixins/permissions'
    export default {
        name: 'login',
        mixins: [permissions],
        methods: {
            logout(){
                storage.remove('user')
                this.$router.push({
                    name: 'login'
                })
            }
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
